import { api, ReactQueryOptions, RouterInputs } from '@api'

type inputType = RouterInputs['ArtistManager']['getPopularArtists']
type queryOptionsType = ReactQueryOptions['ArtistManager']['getPopularArtists']

export const useGetPopularArtists = (input: inputType, options?: queryOptionsType) => {
    return api.ArtistManager.getPopularArtists.useQuery(input, {
        ...options,
        queryKey: ['ArtistManager.getPopularArtists', input],
        staleTime: 15 * 60 * 1000, // 15 mins
    })
}
